{
  "responseShape": "सर्वर की प्रतिक्रिया अपेक्षित प्रारूप से मेल नहीं खाती — कृपया रिफ़्रेश करें।",
  "badRequest": "अमान्य अनुरोध। कृपया अपना इनपुट जाँचें।",
  "forbidden": "आपके पास यह कार्य करने की अनुमति नहीं है।",
  "facilityRequired": "इस मॉड्यूल का इस्तेमाल करने के लिए हेडर में फ़ैसिलिटी चुनें।",
  "notFound": "संसाधन नहीं मिला।",
  "conflict": "संसाधन पहले से मौजूद है।",
  "validation": "सत्यापन त्रुटि।",
  "tooManyRequests": "बहुत अधिक अनुरोध। कृपया बाद में पुनः प्रयास करें।",
  "serverError": "सर्वर त्रुटि। कृपया बाद में पुनः प्रयास करें।",
  "unexpected": "एक अप्रत्याशित त्रुटि हुई।",
  "network": "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जाँचें।",
  "requestSetup": "एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
  "sessionExpired": "आपका सत्र समाप्त हो गया है। कृपया पुनः लॉग इन करें।"
}
